"use client";
import * as React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import { PortraitVideoModalLarge } from "../modal/profile";
import { ArrowLeft, ArrowRight } from "lucide-react";

import SwiperCore from "swiper";

import { useMediaQuery } from "react-responsive";
import { IVideoProfile } from "@/app/etablissement/un-detail-pour-vous/page";

export const PortraitsCarousel = ({ profiles }: { profiles: any }) => {
  SwiperCore.use([Navigation]);

  const swiperRef = React.useRef<SwiperCore>(null);
  const [currentIndex, setCurrentIndex] = React.useState<number>(0);
  const handleSlideChange = (swiper: SwiperCore) => {
    setCurrentIndex(swiper.activeIndex);
  };

  React.useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.on("slideChange", () =>
        handleSlideChange(swiperRef.current!)
      );
    }
  }, []);

  const onSwiper = (swiper: SwiperCore) => {
    // Stocke l'instance de swiper dans le ref
    swiperRef.current = swiper;
  };

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  return (
    <div className="_border _border-red-600 overflow-visible py-4">
      <Swiper
        onSwiper={onSwiper}
        slidesPerView={isDesktopOrLaptop ? 4 : 1.25}
        spaceBetween={30}
        // wrapperClass="py-2"
        slidesOffsetAfter={isDesktopOrLaptop ? 100 : 6}
        slidesOffsetBefore={isDesktopOrLaptop ? 100 : 6}
        centeredSlides={isDesktopOrLaptop ? false : true}
        className="!py-8"
      >
        {profiles.map((profile: any) => (
          <SwiperSlide
            className="_self-stretch"
            style={{ height: "auto" }}
            key={profile.sys.id}
          >
            <div className="mx-0 self-stretch h-full" style={{}}>
              <PortraitCard key={profile.sys.id} profile={profile} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="flex justify-center py-10 gap-x-8">
        <button
          onClick={() => handlePrev()}
          className="flex gap-x-2 items-center hover:underline"
        >
          <ArrowLeft className="w-4 h-4" /> Précédent
        </button>
        <span className="hidden">
          {currentIndex}/{profiles.length}
        </span>
        <button
          onClick={() => handleNext()}
          className="flex gap-x-2 items-center hover:underline"
        >
          Suivant
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export const PortraitCard: React.FC<{ profile: any }> = ({
  profile,
}: {
  profile: IVideoProfile;
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <>
      {isOpen && (
        // <ProfileModal profile={profile} onClose={() => setIsOpen(false)} />
        <PortraitVideoModalLarge
          videoUrl={profile.video.url}
          onClose={() => setIsOpen(false)}
        />
      )}
      <div
        className="pb-8 shadow-xl rounded bg-chess-board bg-[length:160px_auto] cursor-pointer overflow-visible hover:scale-105 transition-transform relative group"
        onClick={() => setIsOpen(true)}
      >
        <div className="">
          <div className="absolute -bottom-4 left-0 right-0 flex justify-center">
            <div className="shadow text-brand-red bg-white p-3 text-xl rotate-6 group-hover:-rotate-6 transition-transform">
              #{profile.rank}
            </div>
          </div>
          <div>
            {profile.image?.url ? (
              <img
                src={`${profile.image?.url}?w=500&h=500&fit=fill`}
                alt={profile.lastName ?? ``}
                width={10}
                height={10}
                className="w-full object-fill rounded-t"
              />
            ) : (
              <div className="w-full bg-white/90 h-full aspect-4/6"></div>
            )}
          </div>
          <div className="bg-white p-3 flex-1">
            <h3 className="text-xl font-bold text-brand-blue">
              <span className="font-normal">
                {profile.firstName} {profile.lastName}
              </span>
            </h3>
            <div className="font-light text-sm text-gray-600">
              {profile.projectCity}
              <br />
              <span className="opacity-70">{profile.projectName}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
